var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        _vm._l(_vm.titleBtns, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "titleBtns",
              class: _vm.current === item ? "active" : "",
              staticStyle: { "margin-right": "0.2rem" },
              on: {
                click: function ($event) {
                  return _vm.handlerBtnsClick(item)
                },
              },
            },
            [_vm._v(" " + _vm._s(item) + " ")]
          )
        }),
        0
      ),
      _c("main", { staticClass: "main" }, [
        _c("div", { staticClass: "mainBoxLeft" }, [
          _c("div", { staticClass: "mainBoxLeftBox" }, [
            _c("div", { staticClass: "imgBox" }, [
              _c(
                "div",
                { staticClass: "imgs" },
                [
                  _c("ResourceUpload", {
                    ref: "upload",
                    attrs: {
                      showFlodNames: ["公司头像"],
                      ossRoute: "companyImage",
                      fileLimit: 1,
                      parentId: String(_vm.datas.id),
                      flodName: "公司头像",
                      listType: "picture-card",
                    },
                    model: {
                      value: _vm.picList,
                      callback: function ($$v) {
                        _vm.picList = $$v
                      },
                      expression: "picList",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "carry" }, [
              _c("p", { staticClass: "p1" }, [_vm._v("绑定手机")]),
              _c("p", [_vm._v(_vm._s(_vm.datas.legalPhone))]),
            ]),
            _c("div", { staticClass: "carry" }, [
              _c("p", { staticClass: "p1" }, [_vm._v("地址")]),
              _c("p", [_vm._v(_vm._s(_vm.datas.adressRegistration))]),
            ]),
            _c("div", { staticClass: "carry" }, [
              _c("p", { staticClass: "p1" }, [_vm._v("成立日期")]),
              _c("p", [
                _vm._v(_vm._s(_vm._f("dateFormat")(_vm.datas.startTime))),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "carry" },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("标语")]),
                _c("el-input", {
                  attrs: { size: "small", placeholder: "请输入内容" },
                  model: {
                    value: _vm.saveDatas.slogan,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "slogan", $$v)
                    },
                    expression: "saveDatas.slogan",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "carry" },
              [
                _c("p", { staticClass: "p2" }, [_vm._v("业务覆盖")]),
                _c("el-input", {
                  staticStyle: { width: "0.8rem", "margin-right": "0.06rem" },
                  attrs: { size: "small", placeholder: "请输入" },
                  model: {
                    value: _vm.saveDatas.countrySize,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "countrySize", $$v)
                    },
                    expression: "saveDatas.countrySize",
                  },
                }),
                _c("p", { staticStyle: { "margin-right": "0.2rem" } }, [
                  _vm._v("个国家"),
                ]),
                _c("el-input", {
                  staticStyle: { width: "0.8rem", "margin-right": "0.06rem" },
                  attrs: { size: "small", placeholder: "请输入" },
                  model: {
                    value: _vm.saveDatas.citySize,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "citySize", $$v)
                    },
                    expression: "saveDatas.citySize",
                  },
                }),
                _c("p", [_vm._v("个城市")]),
                _c(
                  "span",
                  { staticClass: "span1", on: { click: _vm.inquirySetting } },
                  [
                    _vm._v("询单设置"),
                    _c("i", { staticClass: "el-icon-setting" }),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "span1",
                    on: { click: _vm.collectionSetting },
                  },
                  [
                    _vm._v("收款设置"),
                    _c("i", { staticClass: "el-icon-setting" }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "carry",
                staticStyle: {
                  "flex-direction": "column",
                  "align-items": "flex-start",
                },
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "p2",
                    staticStyle: { width: "1.2rem", "margin-bottom": "0.2rem" },
                  },
                  [_vm._v("留给客户的话")]
                ),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    placeholder: "请输入内容",
                    rows: "5",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.saveDatas.customerMessage,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "customerMessage", $$v)
                    },
                    expression: "saveDatas.customerMessage",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "carry",
                staticStyle: {
                  "flex-direction": "column",
                  "align-items": "flex-start",
                },
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "p2",
                    staticStyle: { width: "1.2rem", "margin-bottom": "0.2rem" },
                  },
                  [_vm._v("公司相册")]
                ),
                _c(
                  "div",
                  { staticClass: "imgs" },
                  [
                    _c("ResourceUpload", {
                      ref: "upload1",
                      attrs: {
                        showFlodNames: ["公司相册"],
                        ossRoute: "companyPicture",
                        fileLimit: 99,
                        parentId: String(_vm.datas.id),
                        flodName: "公司相册",
                        listType: "picture-card",
                      },
                      model: {
                        value: _vm.picList1,
                        callback: function ($$v) {
                          _vm.picList1 = $$v
                        },
                        expression: "picList1",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: { visible: _vm.dialogVisible1 },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialogVisible1 = $event
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: _vm.dialogImageUrl,
                        alt: "",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "mainBoxRight" }, [
          _c("div", { staticClass: "mainBoxRightTopBtn" }, [
            _c(
              "div",
              {
                staticClass: "btns",
                staticStyle: { "margin-right": "0.24rem" },
                on: { click: _vm.save },
              },
              [_vm._v(" 保存 ")]
            ),
            _c("div", { staticClass: "btns" }, [_vm._v(" 返回 ")]),
          ]),
          _c("div", { staticClass: "mainBoxRightBox" }, [
            _c("div", { staticClass: "mainBoxRightBoxTop" }, [
              _vm.picList.length > 0
                ? _c("img", {
                    staticClass: "box",
                    attrs: { src: _vm.picList[0].url },
                  })
                : _c("img", { staticClass: "box", attrs: { src: "#" } }),
              _c("div", { staticClass: "box" }, [
                _c("p", { staticClass: "p1" }, [
                  _vm._v(_vm._s(_vm.datas.countrySize)),
                ]),
                _c("p", { staticClass: "p2" }, [_vm._v("国家")]),
              ]),
              _c("div", { staticClass: "box" }, [
                _c("p", { staticClass: "p1" }, [
                  _vm._v(_vm._s(_vm.datas.citySize)),
                ]),
                _c("p", { staticClass: "p2" }, [_vm._v("城市")]),
              ]),
            ]),
            _c("div", { staticClass: "text1" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.datas.mechanismName) +
                  " - " +
                  _vm._s(_vm.datas.slogan) +
                  " "
              ),
            ]),
            _c("div", { staticClass: "text2" }, [
              _c("i", { staticClass: "el-icon-location" }),
              _c("p", { staticClass: "p1" }, [
                _vm._v(_vm._s(_vm.datas.adressRegistration)),
              ]),
            ]),
            _c("div", { staticClass: "text3" }, [
              _c("i", { staticClass: "el-icon-phone" }),
              _c("p", { staticClass: "p1" }, [_vm._v("13910581028")]),
              _c(
                "div",
                { staticClass: "p1", staticStyle: { "margin-left": "auto" } },
                [
                  _vm._v(
                    " 已成立" + _vm._s(_vm.getYear(_vm.datas.startTime)) + "年 "
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "text4" }, [
              _c("div", { staticClass: "rightBox" }),
              _c("p", { staticClass: "p1" }, [
                _vm._v(_vm._s(_vm.saveDatas.customerMessage)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "text5" },
              _vm._l(_vm.picList1, function (item, index) {
                return _c("img", {
                  key: index,
                  staticClass: "imgs",
                  attrs: { src: item.url, alt: "" },
                })
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "text6" },
              _vm._l(_vm.infoDate, function (item, index) {
                return _c("div", { key: index, staticClass: "textBox" }, [
                  _c("p", { staticClass: "p1" }, [_vm._v(_vm._s(item.num))]),
                  _c("p", { staticClass: "p2" }, [_vm._v(_vm._s(item.title))]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c("normsMaintainNew", { ref: "normsMaintainNew" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "询单设置",
            visible: _vm.centerDialogVisible,
            width: "25%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-tabs",
            { on: { "tab-click": _vm.tabClick } },
            [
              _c("el-tab-pane", { attrs: { name: "0", label: "整团" } }),
              _c("el-tab-pane", { attrs: { name: "1", label: "项目" } }),
            ],
            1
          ),
          _c(
            "p",
            { staticStyle: { "margin-bottom": "0.1rem" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { checked: _vm.inquiryGearData.autoTransfer == 1 },
                  on: {
                    change: function ($event) {
                      return _vm.checkboxChange(
                        "autoTransfer",
                        _vm.inquiryGearData.autoTransfer ? 0 : 1
                      )
                    },
                  },
                },
                [_vm._v("自动转发询单到供应商")]
              ),
            ],
            1
          ),
          _c(
            "p",
            { staticStyle: { "margin-bottom": "0.1rem" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { checked: _vm.inquiryGearData.autoSend == 1 },
                  on: {
                    change: function ($event) {
                      return _vm.checkboxChange(
                        "autoSend",
                        _vm.inquiryGearData.autoSend ? 0 : 1
                      )
                    },
                  },
                },
                [_vm._v("收到方案之后自动发送给客户")]
              ),
            ],
            1
          ),
          _vm.inquiryGearData.autoSend
            ? _c(
                "p",
                { staticStyle: { "padding-left": "0.25rem" } },
                [
                  _vm._v("佣金比例% "),
                  _c("el-input", {
                    staticStyle: { width: "1rem" },
                    attrs: { type: "number", size: "mini" },
                    model: {
                      value: _vm.inquiryGearData.commission,
                      callback: function ($$v) {
                        _vm.$set(_vm.inquiryGearData, "commission", $$v)
                      },
                      expression: "inquiryGearData.commission",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.inquiryGearSave },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "收款设置",
            visible: _vm.centerDialogVisible1,
            width: "25%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible1 = $event
            },
          },
        },
        [
          _c(
            "p",
            { staticStyle: { "margin-bottom": "0.1rem" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 0 },
                  model: {
                    value: _vm.saveDatas.paySet,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "paySet", $$v)
                    },
                    expression: "saveDatas.paySet",
                  },
                },
                [_vm._v("团组收款进入专项款")]
              ),
            ],
            1
          ),
          _c(
            "p",
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.saveDatas.paySet,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveDatas, "paySet", $$v)
                    },
                    expression: "saveDatas.paySet",
                  },
                },
                [_vm._v("团组收款进去公司余额")]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }